// src/services/servicesApi.js
import api from "./api";

/**
 * getServices({ tiling: true|false })
 * returns: [{ id, title, subtitle, is_tiling, created_at, cover_image }]
 */
export async function getServices({ tiling = true } = {}) {
  const { data } = await api.get("/services/category", {
    params: { tiling: tiling ? "true" : "false" },
  });
  return Array.isArray(data) ? data : [];
}
